import React from "react";
import { Form, Input, Spin } from 'antd';
import NHFormItem from "../../common/NHFormItem";
import NHSelect from "../../common/NHSelect";
import NHFetch from "../../../utils/NHFetch";
import NHCascader from "../../common/NHCascader";
import NHUeditor from "../../common/NHUeditor";

const baseUrlPath = "/xxfb"; //信息发布管理模块路径

/**
 * 信息发布编辑表单
 */
class EditInitForm extends React.Component {

    static defaultProps = {
        initFormData: {},
    }

    constructor(props) {
        super(props);
        this.state = {
            nr: '',
            loading: false,
            show: false,
        }
    }

    componentDidMount() {
        const { initFormData } = this.props;
        this.setState({ loading: true });
        if (initFormData && initFormData.PKID) {
            NHFetch(baseUrlPath + "/getNr/" + initFormData.PKID, "GET")
                .then(resData => {
                    if (resData.data != null) {
                        this.setState({ nr: resData.data });
                    }
                    this.setState({ show: true });
                }).catch(err => {
                    this.setState({ show: true });
                })
        } else {
            this.setState({ show: true });
        }
    }

    //获取设置富文本编辑器的方法
    setEditor = (editor) => {
        let nr = this.state.nr;
        if (nr) {
            editor.setContent(nr);
        }
        this.setState({ loading: false });
    }

    onChange = (value) => {
        if (value.length > 0) {
            let flbz = value[value.length - 1];
            NHFetch(baseUrlPath + "/checkXxfbflbz", "GET", { "flbz": flbz })
                .then(res => {
                    if (res && res.code == 200 && res.data) {
                        let data = res.data;
                        if (data['data'] == 'success') {
                            //检查内容是否唯一
                        } else {
                            let message = data['message'];
                            //不通过检查
                            this.props.form.setFields({ flbz: { value: [], errors: [new Error(message + '')] } })
                        }
                    } else {

                    }
                });
        }
    }

    render() {
        const { form, initFormData } = this.props;
        let flbz = '';
        if (initFormData.FFLBZ) {
            flbz = [initFormData.FFLBZ, initFormData.FLBZ];
        } else if (initFormData.FLBZ) {
            flbz = [initFormData.FLBZ];
        }

        return (
            <div>
                <Form>
                    <NHFormItem id={'flbz'} label={"分类标志"} required={true} form={form}
                        initialValue={flbz}>
                        <NHCascader sign={"zhxg_yxxt_xxfbfl"} onChange={this.onChange} />
                    </NHFormItem>
                    <NHFormItem id={'tzbt'} label={"信息发布标题"} required={true} form={form} pattern={{ max: 300, message: "标题长度不能超过300字符！" }}
                        initialValue={initFormData.TZBT}>
                        <Input placeholder="标题" />
                    </NHFormItem>
                    <NHFormItem id={'khdlx'} label={"客户端类型"} required={true} form={form}
                        initialValue={initFormData.KHDLX}>
                        <NHSelect sign={"DMK_YXXT_KFDLX"} />
                    </NHFormItem>
                    {this.state.show &&
                        <NHFormItem label={"信息发布内容"} form={form}>
                            <NHUeditor id="content" width={780} Editor={this.setEditor} getContent={this.props.getContent} />
                        </NHFormItem>
                    }
                </Form>
                <Spin spinning={this.state.loading} style={{ position: 'absolute', left: '50%', top: '100px' }} />
                <style jsx global>{`
                .ant-form-item-label{
                    font-weight: bold;
                }
           `
                }</style>
            </div>
        );
    }
}

const EditForm = Form.create()(EditInitForm);

export default EditForm;


// WEBPACK FOOTER //
// ./components/fwwgl/xxfb/EditForm.js